import { createAction, props } from '@ngrx/store';
import { DataType } from '../../models/data-type/data-type.model';

export const loadDataTypes = createAction('[Data Type Facade] Load Data Types');

export const loadDataTypesSuccess = createAction(
    '[Data Type Effect] Load Data Types Success',
    props<{ dataTypes: Array<DataType> }>()
);
